import React, { useState, useEffect } from "react";

function useResendCodeTimer(resendVerificationCode: () => void, resendDuration = 20) {
  const [waitCountdown, setWaitCountdown] = useState(resendDuration);
  const [isCodeResent, setIsCodeResent] = useState(false);
  const [isResendCodeReady, setIsResendCodeReady] = useState(false)

  function onResendCode() {
    resendVerificationCode();
    setIsCodeResent(true);
    setIsResendCodeReady(false);
    setWaitCountdown(resendDuration);
  }

  useEffect(() => {
    setWaitCountdown(resendDuration)
  }, [resendDuration, setWaitCountdown])

  useEffect(() => {
    let intervalId: any;
    if (waitCountdown > 0) {
      intervalId = setInterval(() => {
        setWaitCountdown((t) => t - 1)
      }, 1000)
    } else {
      setIsResendCodeReady(true);
    }

    return () => clearInterval(intervalId);

  }, [waitCountdown, setIsResendCodeReady, setWaitCountdown])

  return {
    onResendCode,
    waitCountdown,
    isCodeResent,
    isResendCodeReady,
  }
}

export {
  useResendCodeTimer
}